export default (function (context) {
  return {
    input: {
      borderWidth: '1px',
      fontSize: context.font.baseFontSize,
      lineHeight: context.font.h5LineHeight,
      vPadding: '8px',
      hPadding: '8px',
      smallFontSize: context.font.baseFontSize,
      smallLineHeight: context.font.h5LineHeight,
      smallVPadding: '2px',
      smallHPadding: '5px'
    },
    colour: {
      // Form elements
      inputBorder: context.colour.neutral300,
      inputBackground: context.colour.white,
      inputText: context.colour.text,
      inputHoverBorder: context.colour.neutral400,
      inputFocusBorder: context.colour.secondary,
      inputFocusBackground: context.colour.white,
      inputFocusText: context.colour.text,
      inputDisabledBorder: context.colour.neutral300,
      inputDisabledBackground: context.colour.neutral100,
      inputDisabledText: context.colour.neutral500,
      inputErrorBorder: context.colour.error,
      inputErrorBackground: context.colour.white,
      inputErrorText: context.colour.errorDark,
      inputErrorFocusBorder: context.colour.errorDark,
      inputErrorFocusBackground: context.colour.white,
      inputErrorFocusText: context.colour.errorDark,
      inputPlaceholderText: context.colour.neutral400
    }
  };
});